import gql from 'graphql-tag';

export const surfaceNodeMovedSubscription = gql`
  subscription surfaceNodeMoved($surface: ID!, $user: ID!) {
    surfaceNodeMoved(surface: $surface, user: $user) {
      id
      surface
      user
      index
      position {
        x
        y
      }
    }
  }
`;
